<template>
  <SidebarSection
    ref="sidebarRef"
    @close="$emit('update:isShow', false)"
    v-if="isShow"
    width="60%"
    @delete="
      () => {
        sidebarRef.$parent.$parent.$parent.$refs.tableRef.$refs.deleteDialog[0].open({
          data: { TaUserGroup: { Id: data?.Id } },
        });
      }
    "
    title="ar_client_detail_group_user"
    :isShow.sync="isShow"
  >
    <ModalGroupUser
      v-if="isShowModal"
      @refetch="
        () => {
          $emit('refetch', data?.Id);
        }
      "
      :data="data"
      :is-show.sync="isShowModal"
    />
    <div class="mt-1">
      <b-row class="m-0 mb-1">
        <b-col md="6">
          <h6 class="content-title">
            {{ $t("ar_voucher_general_information") }}
          </h6>
        </b-col>
        <b-col md="6" class="d-flex justify-content-end">
          <ez-icon
            :class="{ 'd-none': !isValidPermission(AP_UTUG01) }"
            icon="ezAr-icon-edit"
            size="24"
            class="cursor-pointer mx-50"
            color="#114A9F"
            @click="isShowModal = true"
          />
        </b-col>
      </b-row>
      <GeneralInfo leftWidth="90px" rightWidth="130px" :list="listGeneral" />
    </div>
    <div class="divider"></div>
    <div class="mx-2 my-2" style="height: 68%">
      <b-tabs>
        <b-tab v-if="isValidPermission(AP_UTUG02)" title="Phân quyền chức năng">
          <div class="mt-2"></div>
          <SwapData
            :data="exChangeFunctions"
            childrens-expr="Permission"
            displayExpr="NameVi"
            ref="exchangeFunctionRef"
          />
          <!--  <LoadingModalButton
          v-if="data.InActive === 1"
            ref="buttonRef"
            @click="handleUpdateFunctionAuthorize"
            style="margin-left: auto; display: block; margin-right: 6px"
            variant="primary"
            className="px-4 mt-2 mb-3 "
          >
            {{ $t("ar_common_save") }}
          </LoadingModalButton> -->
        </b-tab>

        <b-tab v-if="isValidPermission(AP_UTUG03)" title="Phân quyền dữ liệu">
          <div class="mt-2"></div>
          <!--   <ExChangeData
            :init-selected-ids="data?.DomainTauserGroup?.map((item) => item.TravelAgentId)"
            :is-flatten-data="true"
            :data="datas"
            ref="exchangeDataRef"
          /> -->
          <SwapData
            :data="exChangeDatas"
            displayExpr="CodeName"
            :search-expr="['CodeName']"
            ref="exchangeDataRef"
          />
          <!-- <LoadingModalButton
            v-if="data.InActive === 1"
            ref="buttonRef"
            @click="handleUpdateDataAuthorize"
            style="margin-left: auto; display: block"
            variant="primary"
            className="px-4 mt-3"
          >
            {{ $t("ar_common_save") }}
          </LoadingModalButton> -->
        </b-tab>
      </b-tabs>
      <LoadingModalButton
        v-if="data.InActive === 1"
        ref="buttonRef"
        @click="handleUpdateAuthorize"
        style="margin-left: auto; display: block; margin-right: 6px"
        variant="primary"
        className="px-4 mt-2 mb-3 "
      >
        {{ $t("ar_common_save") }}
      </LoadingModalButton>
    </div>
  </SidebarSection>
</template>

<script>
import ExChangeData from "./ExChangeData.vue";
import GeneralInfo from "../../ultils/General/GeneralInfo.vue";
import SidebarSection from "../../ultils/Sidebar/SidebarSection.vue";

import { defineComponent, ref, computed, getCurrentInstance, watch } from "@vue/composition-api";
import EzTable from "../../ultils/Table/EzTable.vue";
import { AP_UTUG01, AP_UTUG02, AP_UTUG03 } from "@/api/constant";
import LoadingModalButton from "../../ultils/Button/LoadingModalButton.vue";
import { useFetch } from "../../ultils/Hooks/useFetch.ts";
import PermissionButton from "../../ultils/Button/PermissionButton.vue";
import { arClient } from "@/api/ar-client";
import { convertCommonActiveStatus } from "../../ultils/status";
import ModalGroupUser from "./ModalGroupUser.vue";
import SwapData from "./SwapData.vue";

export default defineComponent({
  name: "SidebarGroupUser",
  components: {
    LoadingModalButton,
    ExChangeData,
    SidebarSection,
    GeneralInfo,
    EzTable,
    ModalGroupUser,
    PermissionButton,
    SwapData,
  },
  props: {
    functions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isShow: Boolean,
    datas: {
      type: Array,
      default: () => {
        return [];
      },
    },
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props, { emit }) {
    const buttonRef = ref();
    const sidebarRef = ref();
    const exchangeFunctionRef = ref();
    const exchangeDataRef = ref();
    const isShowModal = ref(false);

    const vm = getCurrentInstance().proxy;
    const groupUserColumns = ref([
      {
        caption: "ar_client_group_user_code",
        field: "UserCode",
      },
      {
        caption: "ar_client_group_user_name",
        field: "UserName",
      },
    ]);
    const dataAuthorizeColumns = ref([
      {
        caption: "ar_common_company_code",
        field: "TravelAgentCode",
      },
      {
        caption: "ar_common_company_name",
        field: "TravelAgentName",
      },
    ]);
    const functionAuthorizeColumns = ref([
      {
        caption: "ar_client_group_user_code",
      },
    ]);
    const listGeneral = computed(() => [
      {
        icon: "code",
        label: "ar_client_group_code",
        content: props.data.TaUserGroupCode,
      },

      {
        icon: "users",
        label: "ar_client_group_name",
        content: props.data.NameVi,
      },
      {
        icon: "place",
        label: "ar_client_company",
        content: props.data.TravelAgentName,
      },
      {
        icon: "bar-chart",
        label: "ar_client_group_type",
        content: props.data.TaUserGroupType,
      },
      {
        icon: "bar-chart",
        label: "ar_client_status",
        variant: vm.$t(convertCommonActiveStatus(props.data.InActive).variant),
        content: vm.$t(convertCommonActiveStatus(props.data.InActive).title),
      },
      {
        icon: "user",
        label: "ar_client_created_person",
        content: props.data.CreatedBy,
      },
      {
        icon: "calendar",
        label: "ar_client_created_date",
        content: vm.formatDate(props.data.CreatedDate),
      },
      {
        icon: "note",
        label: "ar_client_description",
        content: props.data.DescriptionVi,
      },
    ]);
    const columns = ref([
      {
        caption: "ar_client_debit_account_code",
        field: "AccountCode",
        width: "15%",
      },
      {
        caption: "ar_client_site_code",
        field: "PropertyName",
      },
      {
        caption: "ar_client_account_credit_balances",
        field: "CreditBalance",
        formatType: "currency",
        cellTemplate: true,
        isShow: true,
        width: "15%",
      },
      {
        caption: "ar_client_amount_held",
        field: "HoldBalance",
        cellTemplate: true,
        formatType: "currency",
        width: "15%",
      },
      {
        caption: "ar_client_account_debit_balances",
        field: "DebitBalance",
        formatType: "currency",
        cellTemplate: true,
        width: "15%",
      },
    ]);
    const exChangeFunctions = computed(() => {
      let temp = [];
      if (props.functions.length > 0) {
        temp = props.functions.map((func) => {
          return {
            ...func,
            Permission: func.Permission.map((item) => {
              const foundAssignedItem = props.data.PermissionTauserGroup.find(
                (permission) => permission.PermissionId === item.Id
              );
              if (foundAssignedItem) {
                return { ...item, Active: true };
              }
              return { ...item, Active: false };
            }),
          };
        });
      }
      console.log(temp, "2666");
      return temp;
    });
    const exChangeDatas = computed(() => {
      let temp = [];
      if (props.datas.length > 0) {
        temp = props.datas.map((item) => {
          const foundAssignedItem = props.data.DomainTauserGroup.find(
            (permission) => permission.TravelAgentId === item.Id
          );
          if (foundAssignedItem) {
            return { ...item, Active: true, CodeName: `${item.TravelAgentCode} - ${item.NameVi}` };
          }
          return { ...item, Active: false, CodeName: `${item.TravelAgentCode} - ${item.NameVi}` };
        });
      }
      return temp;
    });

    const { fetchData: mutationFunctionAuthorize } = useFetch(arClient.api_AP_UTUG02, {});
    const { fetchData: mutationDataAuthorize } = useFetch(arClient.api_AP_UTUG03, {
      /*   showLoading: false, */
    });
    const afterUpdateAuthorize = () => {
      emit("refetch", props.data?.Id);
      setTimeout(() => {
        buttonRef?.value?.stopLoading();
      }, 500);
    };
    const handleUpdateAuthorize = () => {
      buttonRef?.value?.startLoading();
      const flattedPermission = [];
      if (exchangeFunctionRef.value?.rootData) {
        exchangeFunctionRef.value.rootData.forEach((item) => {
          item.Permission.forEach((perm) => {
            if (perm.Active) {
              flattedPermission.push(perm);
            }
          });
        });
      }
      const tempFunction = {
        TaUserGroup: {
          Id: props.data.Id,
        },
        PermissionTaUserGroup: flattedPermission.map((v) => {
          const temp = { PermissionId: v.Id };
          const foundOldActivePermission = props.data.PermissionTauserGroup.find(
            (v2) => v2.PermissionId === v.Id
          );
          if (foundOldActivePermission) {
            temp["Id"] = foundOldActivePermission.Id;
          }
          return temp;
        }),
      };
      let tempData = {};
      if (exchangeDataRef.value?.rootData) {
        tempData = {
          TaUserGroup: {
            Id: props.data.Id,
          },
          DomainTAUserGroup: exchangeDataRef.value.rootData
            .filter((v) => v.Active)
            .map((v) => {
              const temp = { TravelAgentId: v.Id };
              const foundOldActivePermission = props.data.DomainTauserGroup.find(
                (v2) => v2.TravelAgentId === v.Id
              );
              if (foundOldActivePermission) {
                temp["Id"] = foundOldActivePermission.Id;
              }
              return temp;
            }),
        };
      }
      if (vm.isValidPermission(AP_UTUG03) && !vm.isValidPermission(AP_UTUG02)) {
        mutationDataAuthorize(tempData).then(() => afterUpdateAuthorize());
      } else if (vm.isValidPermission(AP_UTUG02) && !vm.isValidPermission(AP_UTUG03)) {
        mutationFunctionAuthorize(tempFunction).then(() => afterUpdateAuthorize());
      } else {
        Promise.all([
          mutationDataAuthorize(tempData),
          mutationFunctionAuthorize(tempFunction),
        ]).then(() => afterUpdateAuthorize());
      }
    };
    const handleUpdateFunctionAuthorize = () => {};
    const handleUpdateDataAuthorize = () => {
      buttonRef.value.startLoading();
    };

    return {
      AP_UTUG02,
      AP_UTUG03,
      AP_UTUG01,
      exChangeDatas,
      buttonRef,
      exChangeFunctions,
      exchangeFunctionRef,
      exchangeDataRef,
      isShowModal,
      columns,
      listGeneral,
      sidebarRef,
      dataAuthorizeColumns,
      groupUserColumns,
      functionAuthorizeColumns,
      handleUpdateAuthorize,
      handleUpdateDataAuthorize,
      handleUpdateFunctionAuthorize,
    };
  },
});
</script>
